// Header.js

import React, { useState } from 'react';
import './Header.css';
import PopupCard from './PopupCard.js'; // Import your PopupCard component

const Header = () => {
    const [popupActive, setPopupActive] = useState(false);

    const togglePopup = () => {
        setPopupActive(!popupActive);
    };

    return (
        <header>
            <div className="container">
                <div className="logo">
                    <a>WEAPONSENSE</a>
                </div>
                <nav>
                    <ul>
                        <li>
                            <a href="#">Home</a>
                        </li>
                        <li>
                            <a href="#" onClick={togglePopup}>About</a>
                        </li>
                        <li>
                            <a href="#">Services</a>
                        </li>
                        <li>
                            <a href="#">Video</a>
                        </li>
                        <li>
                            <a href="#">Features</a>
                        </li>
                    </ul>
                </nav>
            </div>
            <PopupCard active={popupActive} />
        </header>
    );
};

export default Header;
